import React from 'react';
import fileSaver from 'file-saver';
import type { TFunction } from 'i18next';

import type { SalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { downloadPromotionReport, SalesPromotionReportType } from '@/services/ws-funnel/src/main/resources/rest-api';
import { useLazyRequestLegacy } from '@/js/libs/use-request-legacy';

type DownloadPromotionReportData = {
  downloadReport: () => void;
  isDownloadingReport: boolean;
};

const reportName: Record<SalesPromotionReportType, string> = {
  [SalesPromotionReportType.CONTACT]: 'CONTACTS',
  [SalesPromotionReportType.ACCOUNT]: 'ACCOUNTS',
  [SalesPromotionReportType.OFFER]: 'OFFERS',
  [SalesPromotionReportType.ORDER]: 'ORDERS',
};

type UseDownloadPromotionReport = (
  promotion: SalesPromotionDto,
  type: SalesPromotionReportType,
  t: TFunction,
) => DownloadPromotionReportData;

export const useDownloadPromotionReport: UseDownloadPromotionReport = (promotion, type, t) => {
  const [requestDownloadReport, { pending: isDownloadingReport }] = useLazyRequestLegacy({
    apiMethod: downloadPromotionReport,
  });

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const downloadReport = React.useCallback(async () => {
    const blob = await requestDownloadReport({ salesPromotionId: promotion.id, type });
    fileSaver.saveAs(blob, `${promotion.name} ${t(reportName[type])}.xls`);
  }, [requestDownloadReport, promotion, type, t]);

  return React.useMemo<DownloadPromotionReportData>(() => ({ isDownloadingReport, downloadReport }), [isDownloadingReport, downloadReport]);
};
